/**
 * Event tracker core: sendEvent, formatEventName, getPageTitle.
 * @package AdvancedTrackingManager
 */

import type { AtmConfig } from '@lib/types';
import { createLogger } from '@lib/logger';

const w = globalThis as unknown as Window;

export const getPageTitle = (): string =>
  typeof document !== 'undefined' && document.title ? document.title : '';

export const formatEventName = (
  name: string,
  naming: AtmConfig['eventNaming'] = 'snake_case'
): string => {
  switch (naming) {
    case 'camelCase':
      return name.replaceAll(/_([a-z])/g, (_, c) => c.toUpperCase());
    case 'kebab-case':
      return name.replaceAll('_', '-');
    default:
      return name;
  }
};

export const sendEvent = (
  eventName: string,
  eventData?: Record<string, unknown>,
  config?: AtmConfig
): void => {
  const cfg = config ?? w.atmConfig;
  if (!cfg) return;

  let utmParams: Record<string, string> = {};
  if (w.atmUTMTracker?.getStored) {
    utmParams = w.atmUTMTracker.getStored();
  }
  const formattedName = formatEventName(eventName, cfg.eventNaming);
  const params = { ...(eventData ?? {}), ...utmParams };

  if (typeof w.gtag === 'function') {
    w.gtag('event', formattedName, params);
  } else if (typeof w.dataLayer !== 'undefined') {
    w.dataLayer.push({ event: formattedName, ...params });
  }
  createLogger('ATM Event Tracker', cfg.debugMode).debug(`Event sent: ${eventName}`, params);
};
